export default __webpack_public_path__ + "static/media/739.6ba9ff7a.png";